import * as React from "react";
import { SVGProps, Ref, forwardRef } from "react";
const SvgComponent = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="1em"
        height="1em"
        fill="none"
        viewBox="0 0 16 16"
        ref={ref}
        {...props}
    >
        <path
            fill="var(--sds--ursa-icons--inner-shape-color, transparent)"
            d="M8.7 8.2a.7.7 0 1 1-1.4 0V5.7a.7.7 0 1 1 1.4 0zM8 11a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5"
        />
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M2 8a6 6 0 1 1 12 0A6 6 0 0 1 2 8m6 .9a.7.7 0 0 0 .7-.7V5.7a.7.7 0 1 0-1.4 0v2.5a.7.7 0 0 0 .7.7m-.75 1.35a.75.75 0 1 0 1.5 0 .75.75 0 0 0-1.5 0"
            clipRule="evenodd"
        />
    </svg>
);
const ForwardRef = forwardRef(SvgComponent);
export default ForwardRef;
